export function handleEnterPress(event: KeyboardEvent) {
    event.stopPropagation()
}
